module.exports = __webpack_public_path__ + "static/retmes-ai-data-collect-icon-1365187094ac6e5c9a06792099941de9.svg";